import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'upsc-layout-no-identity',
  templateUrl: './layout-no-identity.component.html',
  styleUrls: ['./layout-no-identity.component.scss']
})
export class LayoutNoIdentityComponent implements OnInit {
  isInternalUser: boolean = false;
  fName: string = '';
  loginName: string = '';
  userDetails;

  constructor(
    private userService: UserService,
    private activatedRoute: ActivatedRoute
  ) {
    this.isInternalUser = this.userService.isInternalUser();
  }

  ngOnInit(): void {
    this.internalUserSetup();
  }

  //Logout only used for internal user right now.
  logout() {
    if (this.isInternalUser) { //internal users
      sessionStorage.clear()
      localStorage.clear();
      window.location.href = environment.roleLevelSecurity.signout;
    }
  }

  //Only runs if user is an internal user. Gives them a name during no-identity layout,
  //So they can click the profile button and logout if they want to.
  internalUserSetup() {
    if (this.isInternalUser) {
      this.activatedRoute.data.subscribe(({ RLSAuthentication }) => { //RLSAuthentication is the name of the variable returned in the Resolver. the variable name MUST match
        if (RLSAuthentication) {
          this.fName = RLSAuthentication.rlsUserDetails.name.substring(0,1);
          this.loginName = RLSAuthentication.rlsUserDetails.name;
        }
      });
    }
  }

}
